import { ApiBlueprint, gitlabAuthApiRef } from "@backstage/frontend-plugin-api";
import { ScmAuth, scmAuthApiRef } from "@backstage/integration-react";

export const scmAuthApi = ApiBlueprint.make({
  name: 'scm-auth',
  params: defineParams =>
    defineParams({
      api: scmAuthApiRef,
      deps: { gitlabAuthApi: gitlabAuthApiRef },
      factory: ({ gitlabAuthApi }) => ScmAuth.merge(
        ScmAuth.forGitlab(gitlabAuthApi),
      ),
    }),
});